import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Inversiones } from './pages/Inversiones';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  useEffect(() => {
    document.title = 'Flash & Go | Compra, Venta y Alquiler de Autos';
  }, []);
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/inversiones" element={<Inversiones data-id="element-5" />} data-id="element-4" />
      </Routes>
    </BrowserRouter>;
}